import React, { Component } from 'react';
import './App.css';
import Calculator from './components/Calculator/Calculator';
import BottomCal from './components/BottomCal/BottomCal';

class App extends Component {
  constructor() {
    super(); 
  }

  componentDidMount() {
    var l = window.location;
    if (l.toString().indexOf('.html') != -1) {
      //meta
      var metalink = document.createElement('meta');
      metalink.setAttribute('name', 'robots');
      metalink.content = 'noindex, nofollow';
      document.getElementsByTagName('head')[0].appendChild(metalink);
    }
    const script = document.createElement("script");
    let e = window.location.host==('www.hsbc.com.au')?'prod':'dev';
    script.src ='https://tags.tiqcdn.com/utag/hsbc/au-rbwm/' + e + '/utag.sync.js';
    // script.src = "https://tags.tiqcdn.com/utag/hsbc/au-rbwm/dev/utag.sync.js";
    script.async = true;
    script.onload = () => this.scriptLoaded();

    document.body.appendChild(script);

    const script_bp = document.createElement("script");
    script_bp.src = "https://calcs.widgetworks.com.au/s/zonire/live.js";
    script_bp.async = true;
    document.body.appendChild(script_bp);

    const script_wg = document.createElement("script");
    script_wg.src = "https://calcs.widgetworks.com.au/widget/widget-scout.min.js";
    script_wg.async = true;
    document.body.appendChild(script_wg);
  }

  scriptLoaded() {
    window.utag_data = {
      page_url : "/calculators/stamp-duty", 
      page_name : "pws:calculators:stamp duty", 
      page_type : "tool", 
      page_language : "en_au",
      page_category : "calculators", 
      page_subcategory : "stamp duty",
      site_type : "single_page",
      page_customer_group : "general",
      page_security_level : "0",
      page_business_line : "rbwm",
      site_section : "pws"
    };

    (function(a,b,c,d,e){
      // Change the 'www.hsbc.com.au' into the acutal application production domain.
      b=document;e=b.domain==('www.hsbc.com.au')?'prod':'dev';
      a='https://tags.tiqcdn.com/utag/hsbc/au-rbwm/' + e + '/utag.js';
      c='script';d=b.createElement(c);d.src=a;
      d.type='text/java'+c;d.async=true;
      a=b.getElementsByTagName(c)[0];a.parentNode.
      insertBefore(d,a)
      })();

    (function(w,t){
      t = w.tms = w.tms || {}; t.queue = t.queue || new Array();
      t.config = {site_type:
      "single_page", trigger_view_on_hashchange: "true"}; //Single Page Application ONLY
      t.track = {viinew: function(u, cb, uid)
      {w.tms.queue.push({event: 'view', data: u, cb: cb, uid: uid});
      return true;},
      link: function(u,
      cb, uid){w.tms.queue.push({event: 'link', data: u, cb: cb,
      uid: uid});return true;}}
      })(window);

    window.TMS.trackView({ 
      "page_url" : "/calculators/stamp-duty", 
      "page_name" : "pws:calculators:stamp duty", 
      "page_type" : "tool", 
      "page_language" : "en_au",
      "page_category" : "calculators", 
      "page_subcategory" : "stamp duty",
      "page_customer_group" : "general",
      "page_security_level" : "0",
      "page_business_line" : "rbwm",
      "site_section" : "pws"
    }); 
    
  }

  render() {
    return (
      <React.Fragment>
        <div id="header-main-container"></div>
          <div className="custom-HSBC-wrapper">
            <Calculator />
            <BottomCal />
          </div>
        <div id="footer-main-container"></div>
      </React.Fragment>
    );
  }
}
export default App;